export type Property = {
    address1: string;
    address2: string;
    billingContact?: string;
    allContacts?: {
        propertyManagement?: PropertyContact;
        regionalManager?: PropertyContact;
        billing?: PropertyContact;
        maintenanceSupervisor?: PropertyContact;
    };
    city: string;
    createdAt: string;
    creator: string;
    deletedAt?: string;
    id: string;
    maintenanceSupervisorContact?: string;
    ownerEntity?: string;
    pmcId: string;
    posAllowed: boolean;
    propertyClass?: string;
    propertyEmail: string;
    propertyMaintenanceSoftware?: string;
    propertyManagementContact?: string;
    propertyManagementSystem?: string;
    propertyNameLegal: string;
    propertyNameMarketing: string;
    propertyPhoneNumber: number;
    imageUrl: string;
    propertyStyle?: string;
    propertyType?: string;
    regionalManagerContact?: string;
    state: string;
    unitCount?: number;
    updatedAt: string;
    zipCode: string;
    catalogId: string;
    sourcingSettings?: SourcingSettings;
    sourcingSettingsReno?: SourcingSettings;
    isPoNumbersRequired: boolean;
    delInstructions: string;
    delRecipientName: string;
    delRecipientPhone?: string;
};

export interface DeliveryInstructions {
    delInstructions?: string;
    delRecipientName?: string;
    delRecipientPhone?: string;
}

export interface Supplier {
    id: string;
    uid: string;
    pa_id: string;
    name: string;
    imageUrl: string;
    brandColor: string;
    operationsActivationStatus: SupplierActivationStatus;
}

export enum SupplierActivationStatus {
    ActionRequired = 'INVALID',
    Pending = 'VERIFYING',
    Verified = 'VERIFIED',
}

export interface SourcingSettings {
    id: string | null;
    mode: string;
    preferredSuppliers: Supplier[] | [];
    sortingMode: string;
}

export interface PropertyContact {
    id: string;
    contactInfo?: string;
    contactType?: string;
    name?: string;
    role?: string;
}

export interface PropertySchema {
    dataList?: Property[];
    selectedData?: Property;
    selectedReportData?: Property;
    selectedPropertyVendorData?: Property;
    selectedId?: string;
    selectedPropertyIdForReports?: string;
    selectedPropertyIdForVendor?: string;
    isLoading: boolean;
    error?: string;
}
